<template>
  <v-container fluid>
    <v-layout row wrap text-center winners__not-found v-if="serverError">
      <v-flex xs12>
        <h1>{{ serverError }}</h1>
      </v-flex>
      <v-flex xs12 py-0 pb-5>
        <v-divider />
      </v-flex>
    </v-layout>

    <v-layout row wrap v-if="!serverError">
      <v-flex xs12>
        <h1>
          {{ $t("pagesTenders.index.title")
          }}{{
            isSearchGlobal ? $t("pagesTenders.index.titleAfterFilter") : ""
          }}
        </h1>
        <!-- <div class="help_tip">Здесь будет страница со списком победителей в тендерах.</div> -->
      </v-flex>
      <v-flex xs12 py-0>
        <v-divider />
      </v-flex>
    </v-layout>
    <v-card :disabled="!isLoaded" tile v-if="!serverError">
      <v-card-text>
        <v-layout align-start justify-start row wrap filters>
          <v-flex shrink :class="{ 'filters--disabled': isDisabledDate }">
            <div class="winners__date">
              <v-menu
                ref="date_from"
                v-model="date_from"
                :close-on-content-click="false"
                offset-y
                transition="scale-transition"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="winners_date_from"
                    :placeholder="$t('pagesTenders.index.date')"
                    prepend-icon="event"
                    v-on="on"
                    v-on:blur="formatDateFrom"
                    v-mask="'##.##.####'"
                    class="pt-0 mt-0"
                    :disabled="isDisabledDate"
                    readonly
                    return-masked-value
                    hide-details
                  ></v-text-field>
                </template>
                <v-date-picker
                  ref="picker"
                  v-model="winnersDateFrom"
                  :max="new Date().toISOString().substr(0, 10)"
                  @change="saveDateFrom"
                  llocale="ru-ru"
                  first-day-of-week="1"
                  no-title
                ></v-date-picker>
              </v-menu>
            </div>
          </v-flex>

          <!-- <v-flex shrink pl-0>
                <v-icon color="primary" @click="getShit">history</v-icon>
          </v-flex>-->

          <v-divider vertical></v-divider>

          <v-flex
            filters__item
            shrink
            :class="{
              'filters__item--active': this.filters.fz == 44,
              'filters--disabled': isDisabledFz,
            }"
          >
            <v-btn
              class="filters__item-button"
              @click="changeFZ(44)"
              :disabled="isDisabledFz"
              >44</v-btn
            >
          </v-flex>
          <v-flex
            filters__item
            shrink
            :class="{
              'filters__item--active': this.filters.fz == 185,
              'filters--disabled': isDisabledFz,
            }"
          >
            <v-btn
              class="filters__item-button"
              @click="changeFZ(185)"
              :disabled="isDisabledFz"
              >185</v-btn
            >
          </v-flex>
          <v-flex
            filters__item
            shrink
            :class="{
              'filters__item--active': this.filters.fz == 223,
              'filters--disabled': isDisabledFz,
            }"
          >
            <v-btn
              class="filters__item-button"
              @click="changeFZ(223)"
              :disabled="isDisabledFz"
              >223</v-btn
            >
          </v-flex>

          <v-divider vertical></v-divider>

          <v-flex
            filters__item
            shrink
            :class="{
              'filters__item--active': this.filters.accept,
              'filters--disabled': isDisabledFlags,
            }"
          >
            <v-btn
              class="filters__item-button"
              @click="toggleAccept()"
              :disabled="isDisabledFlags"
              >{{ $t("pagesTenders.index.inWorks") }}</v-btn
            >
          </v-flex>

          <v-divider vertical></v-divider>

          <v-flex
            filters__item
            shrink
            :class="{
              'filters__item--active': this.filters.favorite,
              'filters--disabled': isDisabledFlags,
            }"
          >
            <v-btn
              class="filters__item-button"
              @click="toggleFavorite()"
              :disabled="isDisabledFlags"
              >{{ $t("pagesTenders.index.myFavorite") }}</v-btn
            >
          </v-flex>

          <v-flex grow></v-flex>

          <v-flex shrink v-if="isSearchGlobal">
            <transition name="slide-fade" mode="out-in">
              <v-layout row wrap filters__search>
                <v-flex shrink>
                  <!--<v-text-field
                    v-model="searchGlobal"
                    label="Глобальный поиск"
                    @keyup.enter="globalSearch"
                    hide-details
                    class="mt-0 pt-0"
                  ></v-text-field>-->
                  <v-chip label disabled :link="false">{{
                    $t("pagesTenders.index.hideExtFilter")
                  }}</v-chip>
                </v-flex>
                <!--<v-flex shrink>
                  <v-autocomplete
                    v-model="searchGlobalField"
                    :items="searchGlobalFieldTypes"
                    label="Поле"
                    class="mt-0 pt-0 filters__search-select"
                    width="30px"
                    hide-details
                  ></v-autocomplete>
                </v-flex>-->
              </v-layout>
            </transition>
          </v-flex>
          <v-flex shrink v-else>
            <transition name="slide-fade" mode="out-in">
              <v-chip label disabled :link="false">{{
                $t("pagesTenders.index.showExtFilter")
              }}</v-chip>
              <!---<v-text-field
                v-model="search"
                append-icon="search"
                label="Поиск в списке"
                hide-details
                class="mt-0 pt-0"
              ></v-text-field>-->
            </transition>
          </v-flex>

          <v-flex shrink>
            <v-switch
              v-model="isSearchGlobal"
              class="mt-0 pt-1"
              hide-details
              :prepend="`Switch 1: ${isSearchGlobal.toString()}`"
            ></v-switch>
          </v-flex>

          <v-flex shrink>
            <v-select
              v-model="columnsSelected"
              :items="columns"
              item-text="name"
              item-disabled="disabledColumn"
              menu-props="overflowY"
              class="mt-0 pt-0"
              return-object
              hide-details
              multiple
            >
              <template v-slot:prepend-item>
                <v-list-tile ripple @click="selectAllColumns">
                  <v-list-tile-action>
                    <div
                      class="v-input--selection-controls__ripple primary--text select-all"
                    ></div>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{
                      $t("pagesTenders.index.selectAll")
                    }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
              <template v-slot:selection="{ item, index }">
                <strong v-if="index === 0">{{ columnsSelected.length }}</strong>
              </template>
            </v-select>
          </v-flex>
        </v-layout>
        <div v-if="isSearchGlobal">
          <v-layout>
            <v-flex shrink>
              <v-switch
                v-model="globals.isDate"
                class="mt-0 pt-1"
                hide-details
                :label="$t('pagesTenders.index.useDate')"
              ></v-switch>
              <v-switch
                v-model="globals.isFz"
                class="mt-0 pt-1"
                hide-details
                :label="$t('pagesTenders.index.useFZ')"
              ></v-switch>
              <v-switch
                v-model="globals.isFlags"
                class="mt-0 pt-1"
                hide-details
                :label="$t('pagesTenders.index.useFlags')"
              ></v-switch>
              <v-switch
                v-model="globals.isMyClient"
                class="mt-0 pt-1"
                hide-details
                :label="$t('pagesTenders.index.useMyClients')"
              ></v-switch>
            </v-flex>
          </v-layout>
          <v-container fluid>
            <v-row>
              <v-col cols="2" sm="12" md="2">
                <v-text-field
                  v-model="globals.advence.price_from"
                  prepend-icon="mdi-currency-rub"
                  :label="$t('pagesTenders.index.priceFrom')"
                  type="number"
                  hide-details
                  class="mt-0 pt-0"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="2" sm="12" md="2">
                <v-text-field
                  v-model="globals.advence.price_to"
                  prepend-icon="mdi-currency-rub"
                  :label="$t('pagesTenders.index.priceTo')"
                  type="number"
                  hide-details
                  class="mt-0 pt-0"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="4" sm="12" md="4">
                <!-- empty space -->
              </v-col>
              <v-col cols="2" sm="12" md="2">
                <v-text-field
                  v-model="globals.advence.price_bg_from"
                  prepend-icon="mdi-currency-rub"
                  :label="$t('pagesTenders.index.priceBGFrom')"
                  type="number"
                  hide-details
                  class="mt-0 pt-0"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="2" sm="12" md="2">
                <v-text-field
                  v-model="globals.advence.price_bg_to"
                  type="number"
                  prepend-icon="mdi-currency-rub"
                  :label="$t('pagesTenders.index.priceBGTo')"
                  hide-details
                  class="mt-0 pt-0"
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <v-container fluid>
            <v-row>
              <v-col cols="4" sm="12" md="4">
                <v-text-field
                  v-model="globals.advence.name"
                  prepend-icon="search"
                  :label="$t('pagesTenders.index.name')"
                  hide-details
                  class="mt-0 pt-0"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="4" sm="12" md="4">
                <v-text-field
                  v-model="globals.advence.inn"
                  prepend-icon="mdi-numeric"
                  type="number"
                  :label="$t('pagesTenders.index.inn')"
                  hide-details
                  class="mt-0 pt-0"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="4" sm="12" md="4">
                <v-text-field
                  v-model="globals.advence.number_kp"
                  prepend-icon="mdi-binoculars"
                  :label="$t('pagesTenders.index.numberKP')"
                  hide-details
                  class="mt-0 pt-0"
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" sm="12" md="4">
                <v-text-field
                  v-model="globals.advence.phone"
                  :label="$t('inputs.phone.name')"
                  hide-details
                  class="mt-0 pt-0"
                  clearable
                  v-mask="'(###) ###-##-##'"
                  prefix="+7"
                  prepend-icon="phone"
                  :rules="rules.phone"
                  @paste="checkPastePhone"
                ></v-text-field>
              </v-col>
              <v-col cols="4" sm="12" md="4">
                <v-text-field
                  v-model="globals.advence.notification_number"
                  prepend-icon="mdi-card-account-details"
                  :label="$t('pagesTenders.index.notificationNumber')"
                  hide-details
                  class="mt-0 pt-0"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="4" sm="12" md="4">
                <v-text-field
                  v-model="globals.advence.region"
                  prepend-icon="search"
                  :label="$t('pagesTenders.index.region')"
                  hide-details
                  class="mt-0 pt-0"
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" sm="12" md="4">
                <v-text-field
                  v-model="globals.advence.email"
                  :label="$t('pagesTenders.index.email')"
                  hide-details
                  class="mt-0 pt-0"
                  clearable
                  prepend-icon="email"
                  :rules="rules.email"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>

          <v-layout>
            <v-flex shrink>
              <v-btn
                @click="globalSearch"
                color="warning"
                class="filters__search-button2"
                :disabled="!isAdvencedButtonSearch"
                large
              >
                {{ $t("pagesTenders.index.search") }}
                <v-icon>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </div>
      </v-card-text>
    </v-card>

    <v-layout row wrap block winners mx-0>
      <v-flex xs12 px-0 v-if="isLoaded && !serverError">
        <v-data-table
          :headers="headers"
          :items="winners"
          :loading="!isLoaded"
          :search="search"
          :options.sync="options"
          sort-by="guaranteeing"
          :sort-desc="true"
          :footer-props="{ 'items-per-page-options': rowsPerPageItems }"
          :server-items-length="total"
          :items2-per-page="30"
          class="winners__table"
        >
          <v-progress-linear
            v-slot:progress
            color="primary"
            v-if="isLoaded"
            indeterminate
          ></v-progress-linear>
          <template v-slot:item="{ item }">
            <tr
              @click="openTender(item.id)"
              :class="{ is_client: item.is_client }"
            >
              <!-- <td
                            class="text-center"
                            v-if="getColumnDisplay('id')"
              >{{ item.idx }}</td>-->
              <!-- <td class="text-center" v-if="getColumnDisplay('status')">
                                <span
                                    :class="`status status_${item.status}`"
                                >{{ getStatusName(item.status) }}</span>
              </td>-->
              <td
                class="text-center"
                v-if="getColumnDisplay('notification_number')"
              >
                {{ item.notification_number }}
              </td>
              <td
                class="text-center winners__table-date"
                v-if="getColumnDisplay('protokol_date')"
              >
                {{ item.protokol_date | formatDate }}
              </td>
              <td class="text-right" v-if="getColumnDisplay('price')">
                {{ item.price | formatPrice }}
              </td>
              <td class="text-right" v-if="getColumnDisplay('guaranteeing')">
                {{ item.guaranteeing | formatPrice }}
              </td>
              <td class="text-center" v-if="getColumnDisplay('winner_name')">
                {{ item.winner_name }} ({{ $t("pagesTenders.index.inn") }}:
                {{ item.winner_inn }})
              </td>
              <td class="text-center" v-if="getColumnDisplay('winner_count')">
                <strong>{{ item.wins_count ? item.wins_count : "-" }}</strong>
              </td>
              <td class="text-center" v-if="getColumnDisplay('region')">
                {{ item.region }}
              </td>
              <td class="text-center" v-if="getColumnDisplay('user_status')">
                <v-layout row>
                  <v-flex>
                    <span
                      :class="`status status__${item.user_status}`"
                      v-if="item.user_status"
                      >{{ getStatusName(item.user_status) }}</span
                    >
                  </v-flex>
                  <!-- <v-flex>
                                        <v-menu>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    color="primary"
                                                    class="winners__table-contacts"
                                                    v-on="on"
                                                >
                                                    <v-icon color="black">info</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-list>
                                                <v-list-tile
                                                    v-for="(item, index) in item.contacts"
                                                    :key="index"
                                                    @click
                                                >
                                                    <v-list-tile-title>{{ item.value }}</v-list-tile-title>
                                                </v-list-tile>
                                            </v-list>
                                        </v-menu>
                  </v-flex>-->
                  <!-- <v-flex>
                                        <v-menu>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    color="primary"
                                                    class="winners__table-contacts"
                                                    v-on="on"
                                                >
                                                    <v-icon color="black">speaker_notes</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-list>
                                                <v-list-tile
                                                    v-for="(item, index) in item.history"
                                                    :key="index"
                                                    @click
                                                >
                                                    <v-list-tile-title>{{ item }}</v-list-tile-title>
                                                </v-list-tile>
                                            </v-list>
                                        </v-menu>
                  </v-flex>-->
                </v-layout>
              </td>

              <!-- <td class="table-actions">
                            <div class="table-actions__block">
                                <v-menu right offset-x>
                                    <div slot="activator" class="table-actions__block-trigger"></div>
                                    <div class="table-actions__block-links">
                                        <div class="table-actions__block-row">
                                            <router-link
                                                :to="{name: 'EditClient', params: {id: item.id}}"
                                                tag="span"
                                                class="table-actions__edit"
                                            >
                                                Изменить
                                                <v-icon>edit</v-icon>
                                            </router-link>
                                        </div>
                                        <div class="table-actions__block-row">
                                            <span
                                                @click="deleteEntry(item)"
                                                class="table-actions__delete"
                                            >
                                                Удалить
                                                <v-icon>delete</v-icon>
                                            </span>
                                        </div>
                                    </div>
                                </v-menu>
                            </div>
              </td>-->
            </tr>
          </template>

          <template v-slot:no-data>
            <div class="winners--empty">
              <h2>{{ $t("pagesTenders.index.emptyData") }}</h2>
            </div>
          </template>
        </v-data-table>
      </v-flex>

      <v-flex xs12 mt-5 v-else>
        <skeleton />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { apiCallTrue } from "@/utils/api";
import statusNames from "@/utils/data/statuses";
import { mask } from "vue-the-mask";
import { helpers } from "@/lib/helpers";
import rules from "@/utils/data/rules";
import Skeleton from "@/components/skeleton";
import formatDate from "@/mixins/filters/formatDate";
import formatPrice from "@/mixins/filters/formatPrice";
import axios from "axios";
import i18n from "@/services/i18n";

export default {
  name: "Winners",
  directives: { mask },
  mixins: [formatDate, formatPrice],
  data: () => ({
    rules,
    filters: {
      fz: 44,
      accept: false,
      favorite: false,
    },
    isFirstLoaded: false,
    isStartAdvencedSearch: false,
    isInitAdvenced: false,
    winners: null,
    isLoaded: false,
    serverError: null,
    selectedItems: [],
    columnsSelected: [],
    search: "",
    isSearchGlobal: false,
    globals: {
      isDate: false,
      isFz: false,
      isFlags: false,
      isMyClient: false,
      advence: {
        phone: "",
        email: "",
        name: "",
        inn: "",
        number_kp: "",
        notification_number: "",
        region: "",
        price_from: null,
        price_to: null,
        price_bg_from: null,
        price_bg_to: null,
      },
    },
    savedStateParams: null,
    searchGlobal: "",
    searchGlobalField: 1,
    searchGlobalFieldTypes: [
      { text: i18n.t("pagesTenders.index.inn"), value: 1 },
      { text: i18n.t("pagesTenders.index.name"), value: 2 },
      { text: i18n.t("pagesTenders.index.numberKP"), value: 3 },
      { text: i18n.t("inputs.phone.name"), value: 4 },
      { text: i18n.t("pagesTenders.index.notificationNumber"), value: 5 },
      { text: i18n.t("pagesTenders.index.region"), value: 6 },
    ],
    currentFilter: null,
    columns: [
      {
        text: i18n.t("pagesTenders.index.table.fields.notification_number"),
        name: i18n.t("pagesTenders.index.table.fields.notification_number"),
        value: "notification_number",
        align: "center",
        sortable: true,
        disabledColumn: true,
      },
      {
        text: i18n.t("pagesTenders.index.table.fields.protokol_date"),
        name: i18n.t("pagesTenders.index.table.fields.protokol_date"),
        value: "protokol_date",
        align: "center",
        sortable: true,
        disabledColumn: false,
      },
      {
        text: i18n.t("pagesTenders.index.table.fields.price"),
        name: i18n.t("pagesTenders.index.table.fields.price"),
        value: "price",
        align: "right",
        sortable: true,
        disabledColumn: false,
      },
      {
        text: i18n.t("pagesTenders.index.table.fields.guaranteeing"),
        name: i18n.t("pagesTenders.index.table.fields.guaranteeing"),
        value: "guaranteeing",
        align: "right",
        sortable: true,
        disabledColumn: false,
      },
      {
        text: i18n.t("pagesTenders.index.table.fields.winner_name"),
        name: i18n.t("pagesTenders.index.table.fields.winner_name"),
        value: "winner_name",
        align: "center",
        sortable: true,
        disabledColumn: false,
      },
      {
        text: i18n.t("pagesTenders.index.table.fields.winner_count"),
        name: i18n.t("pagesTenders.index.table.fields.winner_count"),
        value: "winner_count",
        align: "center",
        sortable: false,
        disabledColumn: false,
      },
      {
        text: i18n.t("pagesTenders.index.table.fields.region"),
        name: i18n.t("pagesTenders.index.table.fields.region"),
        value: "region",
        align: "center",
        sortable: true,
        disabledColumn: false,
      },
      {
        text: i18n.t("pagesTenders.index.table.fields.user_status"),
        name: i18n.t("pagesTenders.index.table.fields.user_status"),
        value: "user_status",
        align: "center",
        sortable: false,
        disabledColumn: false,
      },
    ],
    pagination: {},
    options: {},
    total: 0,
    cancelToken: null,

    rowsPerPageItems: [25, 50, 100],
    date_from: false,
    winners_date_from: null,
    winnersDateFrom:
      localStorage.getItem("current_date") ||
      new Date().toISOString().substr(0, 10),
    statusNames,
  }),
  watch: {
    isSearchGlobal(val) {
      if (val) {
        this.isStartAdvencedSearch = false;
        this.savedStateParams = Object.assign({}, this.filters);
        this.savedStateParams.date = this.winnersDateFrom;
        this.winners = [];
      } else {
        if (this.savedStateParams) {
          this.winnersDateFrom = this.savedStateParams.date;
          this.saveDateFrom(this.winnersDateFrom, false);
          delete this.savedStateParams.date;
          this.filters = Object.assign({}, this.savedStateParams);
          this.savedStateParams = null;
        }
        if (this.isStartAdvencedSearch || this.isInitAdvenced) {
          this.beforeFilterAccept();
          this.isInitAdvenced = false;
          this.getTenders();
        }
      }
    },
    options: {
      handler: function(value, old_value) {
        //console.log("handler", value, old_value);
        /*let isChange = false;
                if(value.page != old_value.page)
                    isChange = true;
                if(value.itemsPerPage != old_value.itemsPerPage)
                console.log("handler", value, old_value);*/
        if (JSON.stringify(value) !== JSON.stringify(old_value))
          this.getTenders();
      },
      immediate: true,
    },
  },
  components: { Skeleton },
  methods: {
    checkPastePhone(e) {
      let clipboardData = e.clipboardData || window.clipboardData;
      let pastedData = clipboardData.getData("Text");
      let phoneData = this.getPhoneNumber("7", pastedData);
      if (phoneData.length == 11) {
        phoneData =
          "(" +
          phoneData.substr(1, 3) +
          ") " +
          phoneData.substr(4, 3) +
          "-" +
          phoneData.substr(7, 2) +
          "-" +
          phoneData.substr(9, 2);
        this.globals.advence.phone = phoneData;
      }

      e.stopPropagation();
      e.preventDefault();
      return false;
    },

    getPhoneNumber(append = "7", otherNumber = null) {
      let result = otherNumber;
      if (!result) result = "";

      result = result.replace(/[+()\s-]/g, "");
      result = result.substr(-10);
      if (result) result = append + result;
      return result;
    },

    toggleAccept() {
      this.filters.accept = !this.filters.accept;
      if (this.filters.accept) this.filters.favorite = false;
      this.beforeFilterAccept();
      if (!this.isSearchGlobal) {
        this.getTenders();
      }
    },
    toggleFavorite() {
      this.filters.favorite = !this.filters.favorite;
      if (this.filters.favorite) this.filters.accept = false;
      this.beforeFilterAccept();
      if (!this.isSearchGlobal) {
        this.getTenders();
      }
    },
    changeFZ(fz) {
      this.filters.fz = fz;
      this.beforeFilterAccept();
      if (!this.isSearchGlobal) {
        this.getTenders();
      }
    },

    beforeFilterAccept() {
      this.options.page = 1;
    },

    dateToDMY(date) {
      var d = date.getDate();
      var m = date.getMonth() + 1; //Month from 0 to 11
      var y = date.getFullYear();
      return (
        "" + (d <= 9 ? "0" + d : d) + "." + (m <= 9 ? "0" + m : m) + "." + y
      );
    },

    getStatusName(id) {
      if (!id) return "";
      return this.statusNames.call[id].name
        ? this.statusNames.call[id].name
        : "";
    },

    async getTenders() {
      this.isLoaded = false;
      let params = {};
      this.winners = [];

      // $favorite = null, , $search = null, $search_type = null, $type = Tender::TYPE_DEFAULT
      if (!this.winners_date_from) {
        this.winners_date_from = this.dateToDMY(new Date(this.winnersDateFrom));
      }

      params.date = this.winnersDateFrom;
      params.page = this.options.page;
      params.limit = this.options.itemsPerPage;
      params.fz = this.filters.fz;
      if (this.filters.accept) params.accept = 1;
      if (this.filters.favorite) params.favorite = 1;

      if (
        Array.isArray(this.options.sortBy) &&
        this.options.sortBy.length > 0
      ) {
        params.sort = this.options.sortBy[0];
        if (
          Array.isArray(this.options.sortDesc) &&
          this.options.sortDesc.length > 0
        ) {
          params.sort_desc = this.options.sortDesc[0] ? 1 : 0;
        }
      }

      if (this.isSearchGlobal) {
        params.is_global = 1;
        if (!this.isEmailGlobal) this.globals.advence.email = "";
        for (let p in this.globals.advence) {
          params["search_" + p] = this.globals.advence[p];
        }
        if (params.search_phone)
          params.search_phone = this.getPhoneNumber("", params.search_phone);

        if (this.globals.isDate) params.is_date = 1;
        if (this.globals.isFz) params.is_fz = 1;
        if (this.globals.isFlags) params.is_flags = 1;
        if (this.globals.isMyClient) params.is_my_client = 1;
      }

      if (!this.isFirstLoaded && !params.sort) {
        this.isLoaded = true;
        this.isFirstLoaded = true;
        return;
      }

      console.log("PAG", this.options.page);

      if (this.cancelToken) {
        this.cancelToken.cancel("Отмена предыдущего ajax запроса");
      }
      this.isFirstLoaded = true;
      const CancelToken = axios.CancelToken;
      this.cancelToken = CancelToken.source();
      await apiCallTrue({
        url: "v1/tenders",
        params,
        cancelToken: this.cancelToken.token,
      })
        .then((response) => {
          this.winners = response.data.data.items;
          this.total = response.data.data.count;
          this.isLoaded = true;
          localStorage.setItem("tender_list_filter", JSON.stringify(params));
          //localStorage.setItem("current_date", this.winnersDateFrom);
          // resolve(response.data.data);
          let pageOffsetH = localStorage.getItem("tender_pageYOffset");
          if (pageOffsetH) {
            setTimeout(() => {
              window.scrollTo(0, pageOffsetH);
            }, 500);
          }
        })
        .catch((error) => {
          this.serverError = error.message;
        })
        .finally(() => {
          this.cancelToken = null;
          localStorage.removeItem("tender_pageYOffset");
        });
    },

    async globalSearch() {
      //clear sortable
      if (this.options) {
        this.options.sortBy = ["guaranteeing"];
        this.options.sortDesc = [true];
      }
      this.isStartAdvencedSearch = true;
      this.beforeFilterAccept();
      this.getTenders();
    },

    getColumns() {
      this.columns.map((column) => {
        this.columnsSelected.push(column);
      });
    },
    getColumnDisplay(key) {
      const columnsArray = this.columnsSelected.map(
        (column) => column.value === key
      );
      return columnsArray.some((item) => item === true);
    },
    selectAllColumns() {
      const total = this.columns.length;
      this.$nextTick(() => {
        if (this.columnsSelected.length === total) {
          this.columnsSelected = ["tenderId"];
        } else {
          this.columnsSelected = this.columns.slice();
        }
      });
    },
    openTender(id) {
      if (window.pageYOffset)
        localStorage.setItem("tender_pageYOffset", window.pageYOffset);
      else localStorage.removeItem("tender_pageYOffset");
      this.$router.push({ name: "ShowTender", params: { id: id } });
    },
    saveDateFrom(date, isGetTenders = true) {
      this.$refs.date_from.save(date);
      this.winners_date_from = this.dateToDMY(new Date(this.winnersDateFrom));
      if (isGetTenders) {
        this.beforeFilterAccept();
        if (!this.isSearchGlobal) this.getTenders();
      }
    },
    formatDateFrom() {
      if (this.winners_date_from) {
        this.winnersDateFrom = this.winners_date_from
          .split(".")
          .reverse()
          .join("-");
      }
    },
  },
  computed: {
    headers() {
      // const actions = { text: "", value: "", sortable: false };
      // return this.columnsSelected.concat(actions);
      return this.columnsSelected;
    },

    isDisabledDate() {
      if (this.isSearchGlobal && !this.globals.isDate) return true;
      return false;
    },

    isDisabledFz() {
      if (this.isSearchGlobal && !this.globals.isFz) return true;
      return false;
    },

    isDisabledFlags() {
      if (this.isSearchGlobal && !this.globals.isFlags) return true;
      return false;
    },

    isEmailGlobal() {
      if (
        this.globals.advence.email &&
        /\S+@\S+\.\S+/.test(this.globals.advence.email)
      ) {
        return true;
      }
      return false;
    },

    isAdvencedButtonSearch() {
      if (!this.isSearchGlobal) return false;

      if (this.globals.isDate) return true;
      if (this.globals.isFz) return true;
      if (this.globals.isFlags) return true;
      /*if(this.globals.isMyClient)
        return true;*/

      if (
        this.globals.advence.name &&
        this.globals.advence.name.trim().length > 2
      ) {
        return true;
      }

      if (this.isEmailGlobal) {
        return true;
      }

      if (
        this.globals.advence.inn &&
        new String(this.globals.advence.inn).trim().length > 2
      ) {
        return true;
      }

      if (
        this.globals.advence.number_kp &&
        this.globals.advence.number_kp.trim().length > 2
      ) {
        return true;
      }

      if (
        this.globals.advence.notification_number &&
        this.globals.advence.notification_number.trim().length > 2
      ) {
        return true;
      }

      if (
        this.globals.advence.region &&
        this.globals.advence.region.trim().length > 1
      ) {
        return true;
      }

      if (
        this.globals.advence.price_from ||
        this.globals.advence.price_to ||
        this.globals.advence.price_bg_from ||
        this.globals.advence.price_bg_to
      ) {
        if (this.globals.advence.price_from && this.globals.advence.price_to) {
          if (
            parseFloat(this.globals.advence.price_to) <
            parseFloat(this.globals.advence.price_from)
          )
            return false;
        }
        if (
          this.globals.advence.price_bg_from &&
          this.globals.advence.price_bg_to
        ) {
          if (
            parseFloat(this.globals.advence.price_bg_to) <
            parseFloat(this.globals.advence.price_bg_from)
          )
            return false;
        }
        return true;
      }

      let phoneData = this.getPhoneNumber("7", this.globals.advence.phone);
      if (phoneData.length == 11) return true;
      return false;
    },
  },
  mounted() {
    //const currentFilter = localStorage.getItem("current_filter");
    let filterStorageSaved = localStorage.getItem("tender_list_filter");
    if (filterStorageSaved) {
      try {
        filterStorageSaved = JSON.parse(filterStorageSaved);
        if (filterStorageSaved.date) {
          this.winnersDateFrom = filterStorageSaved.date;
          this.saveDateFrom(this.winnersDateFrom, false);
        }

        if (this.options) {
          if (filterStorageSaved.limit) {
            this.options.itemsPerPage = filterStorageSaved.limit;
          }
          if (filterStorageSaved.page) {
            this.options.page = filterStorageSaved.page;
          }

          if (filterStorageSaved.sort) {
            this.options.sortBy = [filterStorageSaved.sort];
            this.options.sortDesc = [
              filterStorageSaved.sort_desc ? true : false,
            ];
          }
        }

        if (filterStorageSaved.fz) {
          this.filters.fz = filterStorageSaved.fz;
        }
        if (filterStorageSaved.accept) {
          this.filters.accept = true;
        }
        if (filterStorageSaved.favorite) {
          this.filters.favorite = true;
        }

        if (filterStorageSaved.is_global) {
          this.isSearchGlobal = true;
          this.isStartAdvencedSearch = true;
          this.isInitAdvenced = true;

          for (let p in this.globals.advence) {
            if (filterStorageSaved["search_" + p]) {
              this.globals.advence[p] = filterStorageSaved["search_" + p];
            }
          }
          if (filterStorageSaved.is_date) {
            this.globals.isDate = true;
          }
          if (filterStorageSaved.is_fz) {
            this.globals.isFz = true;
          }
          if (filterStorageSaved.is_flags) {
            this.globals.isFlags = true;
          }
          if (filterStorageSaved.is_my_client) {
            this.globals.isMyClient = true;
          }
        }
        console.log("filterSaved", filterStorageSaved);
      } catch (e) {
        console.warn("filterSaved", filterStorageSaved, e);
      }
    }

    this.isLoaded = false;
    this.getColumns();
  },
  beforeRouteLeave(to, from, next) {
    if (to.name != "ShowTender") {
      helpers.removeTenderFilter();
    }
    next();
  },
};
</script>

<style lang="scss">
table.v-table tbody td:first-child,
table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child),
table.v-table thead th {
  padding: 0 10px !important;
}

.filters {
  padding: 16px 0;

  &--disabled {
    opacity: 0.2;
  }

  .v-select__selections {
    strong {
      font-size: 13px;
      font-weight: 400;
      padding-left: 10px;
    }
    input {
      width: 5px;
      padding: 5px 0;
    }
  }
  .v-select__selection {
    font-size: 13px;
    margin: 6px 0 6px 10px;
    white-space: nowrap;
  }
  &__item {
    span {
      cursor: pointer;
      // display: block;
      // border: 1px solid #ccc;
      // padding: 2px 15px;
      // border-radius: 15px;
      color: #aaa;
      // background: transparent;
      // transition: all 0.3s ease;
    }
    &-button {
      margin: 0 !important;
      box-shadow: 0 0 0 !important;
      cursor: pointer;
      display: block;
      border: 1px solid #ccc;
      padding: 6px 10px 5px !important;
      border-radius: 15px !important;
      background: transparent !important;
      transition: all 0.3s ease;
      height: auto !important;
      min-width: 10px;

      &::before {
        display: none;
      }

      &:hover {
        border-color: #000 !important;

        .v-btn__content {
          color: #000 !important;
        }
      }

      .v-btn__content {
        padding: 0 !important;
        color: #aaa !important;
        font-weight: 400 !important;
      }

      .v-ripple__container {
        display: none !important;
      }
    }

    &--active:not(.filters--disabled) {
      .filters__item-button {
        border-color: #404ce6 !important;
        background: #404ce6 !important;
        .v-btn__content {
          color: #fff !important;
        }

        &:hover {
          border-color: #404ce6 !important;
          background: #404ce6 !important;

          .v-btn__content {
            color: #fff !important;
          }
        }
      }
    }
  }

  &__search {
    &-select {
      max-width: 100px;
    }

    &-button {
      margin: 0 !important;
      box-shadow: 0 0 0 !important;
      cursor: pointer;
      display: block;
      border: 1px solid #ccc;
      padding: 3px 15px 3px !important;
      border-radius: 15px !important;
      background: transparent !important;
      transition: all 0.3s ease;
      height: auto;
      min-width: 10px;

      &::before {
        display: none;
      }

      &:hover {
        border-color: #000 !important;

        .v-btn__content {
          color: #000 !important;
        }
      }

      .v-btn__content {
        padding: 0 !important;
        color: #aaa !important;
        font-weight: 400 !important;
      }
      .v-ripple__container {
        display: none !important;
      }
    }
  }
}

.winners {
  .theme--light.v-table tbody tr:not(:last-child) {
    border: 0;
  }
  &__date {
    max-width: 150px !important;
  }
  &__table {
    thead {
      tr:hover {
        background: #fff !important;
      }
    }
    tr {
      background: #fff !important;
      cursor: pointer;

      &[active] {
        background: #fff !important;
      }
      position: relative;
      &:hover {
        background: rgba(74, 116, 252, 0.1) !important;
        .products__table-line {
          opacity: 1;
        }
        .products__table-actions {
          opacity: 1;
        }
      }
      // td:nth-child(1),
      // th:nth-child(1) {
      //     padding: 0 0 0 32px !important;
      //     position: relative;
      //     .v-icon {
      //         color: transparent !important;
      //     }
      //     .v-input--selection-controls__ripple {
      //         display: inline-block;
      //         vertical-align: middle;
      //         color: transparent;
      //         border: 1px solid #ccc;
      //         height: 14px;
      //         width: 14px;
      //         border-radius: 0;
      //         top: -2px;
      //         left: -2px;
      //         &::after {
      //             content: "";
      //             position: absolute;
      //             top: 1px;
      //             right: 1px;
      //             bottom: 1px;
      //             left: 1px;
      //             background: #4b74ff;
      //             opacity: 0;
      //         }
      //         &.accent--text {
      //             &::after {
      //                 opacity: 1;
      //             }
      //         }
      //     }
      // }
      // td:nth-child(2),
      // th:nth-child(2) {
      //     padding-left: 0 !important;
      // }
      th {
        font-size: 12px !important;
        &.active {
          color: #4b74ff !important;
        }
      }
      &:nth-child(2n + 2),
      &[active]:nth-child(2n + 2) {
        background: #f5f5f5 !important;
      }
    }
    &-actions {
      opacity: 0;
      font-size: 14px !important;
      padding-right: 32px !important;
      text-align: right;
      &-trigger {
        color: #ff0000;
        cursor: pointer;
        .v-icon {
          font-size: 16px;
          margin-right: 2px;
        }
      }
      &-confirm {
        padding: 20px 24px;
        border-radius: 4px;
        background: #fff;
        text-align: right;
        width: 370px;
      }
      &-title {
        text-align: center;
        padding-bottom: 16px;
      }
      &-message {
        float: left;
        max-width: 40%;
        font-size: 12px;
        color: #ff0000;
        text-align: left;
      }
    }
    &-pagination {
      display: inline-block;
      vertical-align: top;
      text-align: center;
      height: 32px;
      width: 32px;
      border-radius: 2px;
      border: 1px solid #aaa;
      margin: 0 10px;
      cursor: pointer;
      &::after {
        content: "";
        display: inline-block;
        vertical-align: top;
        border: 1px solid #666;
        border-width: 1px 1px 0 0;
        height: 6px;
        width: 6px;
        margin-top: 7px;
        position: relative;
      }
      &--left {
        &::after {
          transform: rotate(-135deg);
          right: -1px;
        }
      }
      &--right {
        &::after {
          transform: rotate(45deg);
          left: -1px;
        }
      }
      &--disabled {
        border-color: #eee;
        cursor: no-drop;
        &::after {
          border-color: #eee;
        }
      }
      &-text {
        display: inline-block;
        vertical-align: top;
        margin-top: 5px;
        min-width: 100px;
        text-align: center;
      }
      &-select {
        min-width: 20px;
      }
    }
    &-line {
      width: 3px;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background: #4b74ff;
      opacity: 0;
    }

    &-contacts {
      background: none !important;
      color: #ff0000 !important;
      box-shadow: 0 0 0 !important;
      border: 0 !important;
      display: inline-block;
      vertical-align: top;
      padding: 0;
      height: auto;
      min-width: 10px;

      .v-ripple__container {
        display: none !important;
      }
      .v-btn__content {
        padding: 0 !important;
      }
      &::before {
        display: none;
      }
    }
    &-offer {
      white-space: nowrap;
    }
    &-date {
      white-space: nowrap;
    }
  }

  &__not-found {
    padding-top: 200px;
  }
  &--empty {
    min-height: 500px;
    line-height: 500px;
    vertical-align: middle;
    text-align: center;
  }
}

.btn {
  display: inline-block;
  vertical-align: top;
  border: 1px solid #ff0000;
  background: #ff0000;
  padding: 5px 15px;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-left: 10px;
  &--ghost {
    background: none;
    border-color: #ccc;
    color: #aaa;
  }
}
.theme--light.v-table {
  background: rgba(255, 255, 255, 0.7) !important;
}
// .v-text-field > .v-input__control > .v-input__slot:before,
// .v-text-field > .v-input__control > .v-input__slot:after {
//     display: none;
// }
// .v-input--selection-controls__input {
//     .v-icon {
//         color: transparent !important;
//     }
// }
// .v-input--selection-controls__ripple {
//     display: inline-block;
//     vertical-align: middle;
//     color: transparent;
//     border: 1px solid #ccc;
//     height: 14px;
//     width: 14px;
//     border-radius: 0;
//     top: -2px;
//     left: -2px;
//     &::after {
//         content: "";
//         position: absolute;
//         top: 1px;
//         right: 1px;
//         bottom: 1px;
//         left: 1px;
//         background: #4b74ff;
//         opacity: 0;
//     }
//     &.accent--text,
//     &.primary--text {
//         &::after {
//             opacity: 1;
//         }
//     }
// }
.v-list__tile__action {
  min-width: 32px;
  position: relative;
}
.v-list__tile {
  height: 40px;
}
.v-list__tile__title {
  line-height: 16px;
  height: 16px;
}
.select-all {
  top: 5px;
}
.v-text-field .v-input__append-inner {
  padding: 0;
  margin: 2px 0 0;
}
.v-list--disabled {
  opacity: 0.6;
}
.is_client {
  font-weight: 700;
}
</style>
